import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import { SIA_NAVY } from '../../../constants/siaTheme'
import PersonSearch from './PersonSearch'

function todayISO() {
    return new Date().toISOString().slice(0, 10)
}

const ProspectLogForm = ({ entry, mode, advisers }) => {
    const { flash, errors: pageErrors } = usePage().props
    const manage = mode === 'manage'
    const isEdit = Boolean(entry)
    const [saving, setSaving] = useState(false)

    const form = useForm({
        user_id: entry?.user_id ? String(entry.user_id) : '',
        fecha: entry?.fecha ? String(entry.fecha).slice(0, 10) : todayISO(),
        nombre: entry?.nombre || '',
        apellido_paterno: entry?.apellido_paterno || '',
        apellido_materno: entry?.apellido_materno || '',
        telefono: entry?.telefono || '',
        email: entry?.email || '',
        nombre_escuela: entry?.nombre_escuela || '',
        zona_escolar: entry?.zona_escolar || '',
        localidad: entry?.localidad || '',
        municipio: entry?.municipio || '',
        observaciones: entry?.observaciones || '',
    })

    const fieldError = (key) => {
        const e = form.errors[key] || pageErrors?.[key]
        return Array.isArray(e) ? e[0] : e
    }

    const indexRoute = 'prospect-log.index'
    const pathPrefix = 'admin/bitacora-prospectos'

    const submit = (e) => {
        e.preventDefault()
        setSaving(true)
        const opts = {
            preserveScroll: true,
            onFinish: () => setSaving(false),
        }
        if (isEdit) {
            form.put(route('prospect-log.update', entry.id), opts)
        } else {
            form.post(route('prospect-log.store'), opts)
        }
    }

    const Reqd = () => <span className="text-danger">*</span>

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={pathPrefix + (isEdit ? `/${entry.id}/edit` : '/create')} />
            </span>

            <div
                className="rounded-2 mb-6 py-4 px-4 text-center text-white text-uppercase fw-bold fs-5"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Datos del registro
            </div>

            <Card className="card-flush shadow-sm mb-10">
                <Card.Body className="py-8 px-6 px-lg-10">
                    <div className="text-center mb-8 pb-4 border-bottom border-dashed">
                        <span className="text-gray-700 fw-semibold text-uppercase fs-7">Información necesaria para registro</span>
                    </div>

                    <Form onSubmit={submit}>
                        {manage && advisers && (
                            <Row className="g-6 mb-6">
                                <Col md={12}>
                                    <Form.Label className="fw-bold">
                                        Asesor <Reqd />
                                    </Form.Label>
                                    <PersonSearch
                                        options={advisers}
                                        value={form.data.user_id}
                                        invalid={Boolean(fieldError('user_id'))}
                                        onChange={(id) => form.setData('user_id', id)}
                                    />
                                    {fieldError('user_id') && <div className="invalid-feedback d-block">{fieldError('user_id')}</div>}
                                </Col>
                            </Row>
                        )}

                        <Row className="g-6 mb-6">
                            <Col md={6} lg={4}>
                                <Form.Label className="fw-bold">
                                    Fecha <Reqd />
                                </Form.Label>
                                <Form.Control
                                    type="date"
                                    value={form.data.fecha}
                                    onChange={(e) => form.setData('fecha', e.target.value)}
                                    className={fieldError('fecha') ? 'is-invalid' : ''}
                                />
                                {fieldError('fecha') && <div className="invalid-feedback d-block">{fieldError('fecha')}</div>}
                            </Col>
                        </Row>

                        <Row className="g-6 mb-6">
                            <Col md={12}>
                                <Form.Label className="fw-bold">
                                    Nombre <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.nombre}
                                    onChange={(e) => form.setData('nombre', e.target.value)}
                                    className={fieldError('nombre') ? 'is-invalid' : ''}
                                />
                                {fieldError('nombre') && <div className="invalid-feedback d-block">{fieldError('nombre')}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Apellido paterno <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.apellido_paterno}
                                    onChange={(e) => form.setData('apellido_paterno', e.target.value)}
                                    className={fieldError('apellido_paterno') ? 'is-invalid' : ''}
                                />
                                {fieldError('apellido_paterno') && <div className="invalid-feedback d-block">{fieldError('apellido_paterno')}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Apellido materno <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.apellido_materno}
                                    onChange={(e) => form.setData('apellido_materno', e.target.value)}
                                    className={fieldError('apellido_materno') ? 'is-invalid' : ''}
                                />
                                {fieldError('apellido_materno') && <div className="invalid-feedback d-block">{fieldError('apellido_materno')}</div>}
                            </Col>
                        </Row>

                        <Row className="g-6 mb-6">
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Teléfono <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.telefono}
                                    onChange={(e) => form.setData('telefono', e.target.value)}
                                    className={fieldError('telefono') ? 'is-invalid' : ''}
                                />
                                {fieldError('telefono') && <div className="invalid-feedback d-block">{fieldError('telefono')}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Correo electrónico <Reqd />
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    value={form.data.email}
                                    onChange={(e) => form.setData('email', e.target.value)}
                                    className={fieldError('email') ? 'is-invalid' : ''}
                                />
                                {fieldError('email') && <div className="invalid-feedback d-block">{fieldError('email')}</div>}
                            </Col>
                        </Row>

                        <Row className="g-6 mb-6">
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Nombre de la escuela <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.nombre_escuela}
                                    onChange={(e) => form.setData('nombre_escuela', e.target.value)}
                                    className={fieldError('nombre_escuela') ? 'is-invalid' : ''}
                                />
                                {fieldError('nombre_escuela') && <div className="invalid-feedback d-block">{fieldError('nombre_escuela')}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Zona escolar <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.zona_escolar}
                                    onChange={(e) => form.setData('zona_escolar', e.target.value)}
                                    className={fieldError('zona_escolar') ? 'is-invalid' : ''}
                                />
                                {fieldError('zona_escolar') && <div className="invalid-feedback d-block">{fieldError('zona_escolar')}</div>}
                            </Col>
                        </Row>

                        <Row className="g-6 mb-6">
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Localidad <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.localidad}
                                    onChange={(e) => form.setData('localidad', e.target.value)}
                                    className={fieldError('localidad') ? 'is-invalid' : ''}
                                />
                                {fieldError('localidad') && <div className="invalid-feedback d-block">{fieldError('localidad')}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label className="fw-bold">
                                    Municipio <Reqd />
                                </Form.Label>
                                <Form.Control
                                    value={form.data.municipio}
                                    onChange={(e) => form.setData('municipio', e.target.value)}
                                    className={fieldError('municipio') ? 'is-invalid' : ''}
                                />
                                {fieldError('municipio') && <div className="invalid-feedback d-block">{fieldError('municipio')}</div>}
                            </Col>
                        </Row>

                        <Row className="g-6 mb-8">
                            <Col md={12}>
                                <Form.Label className="fw-bold">Observaciones</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    value={form.data.observaciones}
                                    onChange={(e) => form.setData('observaciones', e.target.value)}
                                    className={fieldError('observaciones') ? 'is-invalid' : ''}
                                />
                                {fieldError('observaciones') && <div className="invalid-feedback d-block">{fieldError('observaciones')}</div>}
                            </Col>
                        </Row>

                        <div className="d-flex flex-column align-items-center gap-4">
                            <Button type="submit" variant="primary" disabled={saving || form.processing}>
                                {saving ? 'Guardando…' : 'Guardar'}
                            </Button>
                            <Link href={route(indexRoute)} className="btn btn-sm btn-light">
                                ← Regresar al listado
                            </Link>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Row>
    )
}

ProspectLogForm.layout = (page) => <Layout title="Bitácora de prospectos">{page}</Layout>

export default ProspectLogForm
